// getUserValuesForPath currently serves two purposes
// First, it checks to see if the user is a regular member or an internal user on a memberServices route
// Second, it creates an authUser object that is used to pass user data to mfe-catalog-tools
// When this repo is fully migrated to auth-frontend-tools, the else here can be refactored to simply return the user object.
import { MemberExperienceUserFromIdToken } from '@guildeducationinc/auth-frontend-tools';
import { UserType } from '@src/typings/mfeCatalogTools';

const isMemberServices = (location: Location) => {
	return location.pathname.includes('memberservices');
};

export const getUserValuesForPath = (user: MemberExperienceUserFromIdToken): UserType => {
	if (isMemberServices(window.location)) {
		const employerUuid = location.pathname.split('/')[2];
		const memberUuid = location.pathname.split('/')[3];
		return {
			id: memberUuid,
			email: user.email,
			employee_id: user.employee_id,
			employer: user.employer,
			employer_uuid: employerUuid,
			firstName: user.firstName,
			lastName: user.lastName,
		};
	} else {
		return {
			id: user.id,
			email: user.email,
			employee_id: user.employee_id,
			employer: user.employer,
			employer_uuid: user.employer_uuid,
			firstName: user.firstName,
			lastName: user.lastName,
		};
	}
};
